<!--
 * @Description: 布局中表单配置
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-form :model="data.form" layout="vertical" label-align="left" ref="layoutConfigRef">
    <jw-form-item v-if="!splitType" field="name" :label="$t('布局名称')" asterisk-position="end" :rules="{ required: true, message: $t('请输入布局名称') }" :validate-trigger="['blur', 'change']">
      <jw-input v-model.trim="data.form.name" @change="formChange" :max-length="300" :placeholder="$t('请输入布局名称')" />
    </jw-form-item>
    <jw-form-item :label="$t('快捷按钮')" asterisk-position="end" class="form-btn-group-item">
      <btn-group :list="data.form.layoutDetailBtnModules?.[150]" @cb="onBtnConfigChange" type="150" popup-container=".layout-config-container-content" />
    </jw-form-item>
    <jw-form-item v-if="data.source == 2" :label="$t('外显数量')" asterisk-position="end">
      <jw-select popup-container=".page-layout-config-area" :trigger-props="{ updateAtScroll: true }" :options="btnCountShowOptions" v-model="data.form.showBtnCountModel" @change="formChange" />
    </jw-form-item>
  </jw-form>
</template>

<script setup>
import { reactive, watchEffect, inject } from 'vue';
import { btnCountShowOptions } from '@/utils/const.js';
import btnGroup from '@/views/setting/sys-fields/page-layout/components/btn-group/btn-group.vue'; //操作按钮组合
const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式

const emits = defineEmits(['cb']);
const props = defineProps({
  form: {
    //数据
    type: Object,
    default: () => {
      return {};
    }
  }
});
const data = reactive({
  form: {
    name: '', //布局名称
    layoutDetailBtnModules: '', //通用按钮
    showBtnCountModel: '' //外显数量
  },
  source: inject('sharedConfigData').source
});
watchEffect(() => {
  data.form = props.form;
});
const onBtnConfigChange = (callBack) => {
  data.form.layoutDetailBtnModules[callBack.type] = callBack.data;
  emits('cb', data.form);
};
//数据变更
const formChange = () => {
  emits('cb', data.form);
};
</script>
<style scoped lang="less">
@import './layout-form-config.less';
</style>
